<template>
  <div class="box box--client">
    <div class="box-logo">
      <ImageWrapper :file="box.idLogo" :key="box.idLogo"></ImageWrapper>
    </div>
    <div class="box-tag">
      <span v-if="box._embedded.Country">{{box._embedded.Country.value}}</span>
      <span v-if="box._embedded.Category">{{box._embedded.Category.value}}</span>
      <span v-if="box._embedded.Sector" class="box-sector">{{box._embedded.Sector.value}}</span>
    </div>
    <router-link :to="`clients/${box.idClient}`" class="box-title" :href="box.link"><span>{{box.name}}</span></router-link>
    <a target="_blank" class="box-link2">View details</a>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {slugify} from "@/helpers/slugify";
export default {
  name: "ClientBox",
  components: {ImageWrapper},
  props: ['box'],
  methods: {
    slugify: slugify
  }
}
</script>
